<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Booking" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<!-- <button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="exportAll"
					>
						{{ $t("export_all") }}
					</button> -->
					<button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="reloadTable"
					>
						<i class="fa fa-sync"></i>
						Refresh Table
					</button>
					<button
						type="button"
						class="btn btn-primary btn-with-shadow"
						data-toggle="modal"
						@click="openAddEditModal"
					>
						{{ $t("add") }}
					</button>
				</div>
			</div>
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
		<app-table
  			v-if="userPermissions.length > 0"
			:id="tableId"
			:options="options"
			@action="getListAction"
		/>

		<!-- <app-add-modal
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/> -->

		<placement-booking-table-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			:row-data="rowData"
			:value="value"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/>
		<placement-booking-cancel-table-form
			v-if="isCancelModalActive"
			:table-id="tableId"
			:form-id="formIdCancel"
			:row-data="rowData"
			:value="value"
			:selected-url="selectedUrl"
			@close-modal="closeCancelModal"
		/>
		<placement-booking-reschedule-table-form
			v-if="isRescheduleModalActive"
			:table-id="tableId"
			:form-id="formIdReschedule"
			:row-data="rowData"
			:value="value"
			:selected-url="selectedUrl"
			@close-modal="closeRescheduleModal"
		/>
		<placement-booking-cancel-result-table-form
			v-if="isCancelResultModalActive"
			:table-id="tableId"
			:form-id="formIdCancelResult"
			:row-data="rowData"
			:value="value"
			:selected-url="selectedUrl"
			@close-modal="closeCancelResultModal"
		/>
		<placement-booking-approve-table-form
			v-if="isApproveModalActive"
			:table-id="tableId"
			:form-id="formIdApprove"
			:row-data="rowData"
			:value="value"
			:selected-url="selectedUrl"
			@close-modal="closeApproveModal"
		/>
		<!-- <placement-booking-results-table-form
			v-if="isResultsModalActive"
			:table-id="tableId"
			:form-id="formIdResults"
			:row-data="rowData"
			:value="value"
			:selected-url="selectedUrl"
			@close-modal="closeResultsModal"
		/> -->

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="confirmed"
			@cancelled="cancelled"
		/>
		
		<modal-view-p-d-f
			v-if="showPDF"
			:selected-url="pdfUrl"
			@close-modal="closeModalViewPdf"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";
import { PlacementBookingTableSchema } from "./PlacementBookingTableSchema";
import { urlGenerator } from "../../../../../../../Helpers/AxiosHelper";
import ModalViewPDF from "./ModalViewPDF.vue";

export default {
	components: {
		ModalViewPDF,
	},
	extends: CoreLibrary,
	inject: ["eventHub"],
	name: "PlacementBookingTable",
	mixins: [PlacementBookingTableSchema],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		leadProfilePlacementSubTabLists: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	data() {
		return {
        	userPermissions: [],
			// closeModalViewPdf: false,
			showPDF: false,
		}
	},
	async created() {
		await this.fetchPermission(); 
		this.options.columns = [...this.tableColumns];
	},
	mounted() {
		
		window.handleAttend = (id) => {
			this.openAttend(id);
		};
		window.handleReschedule = (id) => {
			this.openReschedule(id);
		};
		window.handleCancelBooking = (id) => {
			this.openCancelBooking(id);
		};
		
		window.handleViewClick = (id) => {
			this.openView(id);
		};
		window.handleResultClick = (id) => {
			this.openResult(id);
		};
		window.handleDownloadPdfClick = (id) => {
			this.openDownloadPdf(id);
		};
		window.handleApproveResult = (id) => {
			this.approveResult(id);
		};
		window.handleCancelResult = (id) => {
			this.openCancelResult(id);
		};
		
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		
		async fetchPermission() {
			try {
				const res = await axios.get('/getPermission');
				this.userPermissions = res.data.permissions || [];
			} catch (err) {
				console.error(err);
			}
		},
		can(permission) {
			return Array.isArray(this.userPermissions) && this.userPermissions.includes(permission);
		},
		openCancelBooking(id){
			this.selectedUrl = "/transaction/placement/" + id;
			this.openCancelModal();
		},
		openReschedule(id){
			this.selectedUrl = "/transaction/placement/" + id;
			this.openAddEditModal();
		},
		openAttend(id){
			Swal.fire({
				title: "Are you sure?",
				text: "",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes",
			}).then((result) => {
				if (result.isConfirmed) {
					this.axiosPatch({
						url: `/transaction/placement/${id}/attend`,
					})
						.then((response) => {
							Swal.fire({
								title: "Success",
								text: "Successfully.",
								icon: "success",
								confirmButtonText: "Ok",
							});
						})
						.catch(( error ) => {
							// Trigger after error
							Swal.fire({
								title: "Error!",
								text: error.response.data.message,
								icon: "error",
								confirmButtonText: "Ok",
							});
						})
						.finally(() => {
							this.$hub.$emit("reload-" + this.tableId);
						});
				}
			});
		},
		openResult(id) {
			const url = `/transaction/placement/result/${id}`;
			location.href = url; 
		},
		openView(id){
			this.pdfUrl = `/transaction/placement/viewPDF/${id}`;
			this.showPDF = true;
		},
		
		closeModalViewPdf() {
			this.showPDF = false;
		},
		openDownloadPdf(id) {
			const url = `/transaction/placement/downloadPdf/${id}`;
			window.open(url, "_blank"); // buka di tab baru
		},
		/**
		 * for open add edit modal
		 */
		openCancelResult(id){
			
			this.selectedUrl = "/transaction/placement/" + id;
			this.isCancelResultModalActive = true;
			this.preloader = false;
		},
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},
		openCancelModal(){
			this.isCancelModalActive = true;
		},
		closeCancelModal() {
			$("#placement-booking-cancel-table-form").modal("hide");
			this.isCancelModalActive = false;
			this.reSetData();
		},
		openRescheduleModal(){
			this.isRescheduleModalActive = true;
		},
		approveResult(id){
			this.selectedUrl = "/transaction/placement/" + id;
			this.isApproveModalActive = true;
			this.preloader = false;
		},
		closeRescheduleModal() {
			$("#placement-booking-reschedule-table-form").modal("hide");
			this.isRescheduleModalActive = false;
			this.reSetData();
		},
		closeCancelResultModal() {
			$("#placement-booking-cancel-result-table-form").modal("hide");
			this.isCancelResultModalActive = false;
			this.reSetData();
		},
		closeApproveModal() {
			$("#placement-booking-approve-table-form").modal("hide");
			this.isApproveModalActive = false;
			this.reSetData();
		},
		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#placement-booking-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},
		closeResultsModal() {
			$("#placement-results-form").modal("hide");
			this.isResultsModalActive = false;
			this.reSetData();
		},
		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;

			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = "/transaction/placement/" + this.rowData.id;
				this.openAddEditModal();
			} else if (actionObj.title == "Reschedule") {
				this.selectedUrl = "/transaction/placement/" + this.rowData.id;
				this.openRescheduleModal();
			} else if (actionObj.title == "Cancel") {
				this.selectedUrl = "/transaction/placement/" + this.rowData.id;
				this.openCancelModal();
			}  else if (actionObj.title == "Attended") {
				Swal.fire({
					title: "Are you sure?",
					text: "",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Yes",
				}).then((result) => {
					if (result.isConfirmed) {
						this.axiosPatch({
							url: `/transaction/placement/${this.rowData.id}/attend`,
						})
							.then((response) => {
								Swal.fire({
									title: "Success",
									text: "Successfully.",
									icon: "success",
									confirmButtonText: "Ok",
								});
							})
							.catch(( error ) => {
								// Trigger after error
								Swal.fire({
									title: "Error!",
									text: error.response.data.message,
									icon: "error",
									confirmButtonText: "Ok",
								});
							})
							.finally(() => {
								this.$hub.$emit("reload-" + this.tableId);
							});
					}
				});
			} else if (
				actionObj.title != "Delete" ||
				actionObj.title != this.$t("edit")
			) {
				// this.selectedUrl = `${this.Endpoint}/${rowData.id}`;
				this.openAddEditModal();
			}
			
			this.preloader = false;
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			// let url = `${this.Endpoint}/${this.rowData.id}`;
			let url = PLACEMENT + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		reloadTable() {
			this.$hub.$emit("reload-" + this.tableId);
		},
		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
